/********************************************************************
 * ADOBE CONFIDENTIAL
 *
 * Copyright 2025 Adobe
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

export type BackgroundTheme = 'light' | 'dark';

/**
 * Fixed hero background shown to all users (including DX), one per theme.
 * Replaces the previous per-session random selection.
 */
export const heroBackground: Record<BackgroundTheme, URL> = {
	light: new URL('./AH2-bg-hero-light.jpg?as=webp', import.meta.url),
	dark: new URL('./AH2-bg-hero-dark.jpg?as=webp', import.meta.url),
};

/**
 * Gets the hero background image for the specified theme.
 * All users see the same fixed image per theme — no randomization.
 *
 * @param theme - The theme to get the background for ('light' or 'dark')
 * @returns The URL path to the hero background image
 *
 * @example
 * const background = getSelectedBackground('light');
 * // Returns: '/backgrounds/AH2-bg-hero-light.jpg'
 */
export const getSelectedBackground = (theme: BackgroundTheme): string =>
	heroBackground[theme].toString();
